import styled from 'styled-components'
import { Row } from 'antd'

export const StyledTabWrapper = styled(Row)`
  background-color: var(--white);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  margin: 50px auto;
  max-width: 1152px;

  .items-wrapper {
    padding: 25px 15px 0 15px;
    width: 100%;
  }
  h1 {
    color: var(--cognac);
    text-align: center;
  }
  .ant-menu {
    border-radius: 0 !important;
    width: 100%;
    border-bottom: 1px solid var(--light-grey);
    .ant-menu-item {
      min-width: 160px;
      text-align: center;
    }
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    .items-wrapper {
      padding: 20px;
    }
  }
`
export const StyledPromosWrapper = styled(Row)`
  padding: 51px 0;
  display: flex;
  flex-direction: column;
  .btn-wrapper {
    margin-top: 35px;
  }
`
export const StyledNewsWrapper = styled(Row)`
  min-height: 350px;
  margin: 50px auto;
  h2 {
    color: var(--cognac);
    text-align: center;
  }
`
